{
  "es": {
    "task_assignment": {
      "actions": {
        "confirm": "Marcar como completada",
        "create": "Tarea",
        "reopen": "Reabrir",
        "update": "Editar tarea"
      },
      "assignee_types": {
        "customer": "Cliente",
        "employee": "Empleado",
        "partner": "Colaborador"
      },
      "attributes": {
        "assignee": "Responsable",
        "assignees": "Responsables",
        "created_at": "Creado",
        "due_date": "Fecha límite",
        "project": "Proyecto",
        "published": "Publicada",
        "status": "Estado",
        "task": "Tarea",
        "unit": "Unidad"
      },
      "labels": {
        "add_assignee": "Añadir un responsable…",
        "add_customers": "Añadir clientes",
        "already_assigned": "Esta tarea ya está añadida a esta unidad.",
        "completed": "Completadas",
        "confirm_message": "¿Seguro que quieres marcar esta tarea como completada?",
        "customers": "Clientes",
        "my_tasks": "Mis tareas",
        "no_assignees": "Todavía no hay responsables.",
        "no_assignments": "Todavía no hay tareas.",
        "no_assignments_task": "Todavía no hay asignaciones para esta tarea.",
        "no_assignments_unit": "Todavía no hay tareas para esta unidad.",
        "publish_all": "Publicar todo",
        "publish_customers": "Publicar para los clientes de cada unidad",
        "published": "Publicada",
        "required": "Este campo es obligatorio",
        "select_task": "Selecciona una tarea",
        "upload_hint": "Sube el documento o los documentos solicitados para completar esta tarea.",
        "uploaded_documents": "Documentos subidos"
      },
      "statuses": {
        "completed": "Completada",
        "draft": "Borrador",
        "pending": "Pendiente"
      },
      "toasts": {
        "completed": "Tarea completada",
        "create": "Tarea creada",
        "delete": "Tarea eliminada",
        "uncompleted": "Tarea reabierta",
        "update": "Tarea actualizada"
      }
    }
  }
}
